import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Header from './components/Header';
import ConfigPanel from './components/ConfigPanel';
import RecordingDisclaimer from './components/RecordingDisclaimer';
import { OperatorConfigProvider } from './hooks/useOperatorConfig';
import { ConnectionStatusProvider } from './hooks/useConnectionStatus';
import { AuthProvider, useAuth } from './hooks/useAuth';
import LoginPage from './pages/LoginPage';
import useBreakpoint from './hooks/useBreakpoint';

export default function App() {
  return (
    <OperatorConfigProvider>
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    </OperatorConfigProvider>
  );
}

function AppShell() {
  const [configOpen, setConfigOpen] = useState(false);
  const { isAuthenticated, isReady } = useAuth();
  const { isMobile } = useBreakpoint();

  if (!isReady) {
    return (
      <div className="app-shell" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
            alignItems: 'center',
            color: '#cbd5f5',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
          }}
        >
          <span style={{ fontSize: '0.85rem', color: '#64748b' }}>Verifying session</span>
          <span
            style={{
              width: '3rem',
              height: '3rem',
              borderRadius: '9999px',
              border: '4px solid rgba(148, 163, 184, 0.4)',
              borderTopColor: '#2563eb',
              animation: 'spin 1s linear infinite',
              display: 'inline-block',
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="app-shell">
      {isAuthenticated ? (
        <ConnectionStatusProvider>
          <Header onOpenSettings={() => setConfigOpen(true)} />
          <main className="content">
            <Outlet />
          </main>
        </ConnectionStatusProvider>
      ) : (
        <LoginPage />
      )}
      <ConfigPanel open={configOpen} onClose={() => setConfigOpen(false)} />
      <RecordingDisclaimer />
      <Toaster
        position={isMobile ? 'bottom-center' : 'bottom-right'}
        toastOptions={{
          style: {
            background: 'rgba(15, 23, 42, 0.92)',
            color: '#e2e8f0',
            border: '1px solid rgba(148, 163, 184, 0.3)',
            boxShadow: '0 20px 45px -20px rgba(30, 64, 175, 0.7)',
            fontWeight: 500,
            letterSpacing: '0.01em',
          },
          success: {
            iconTheme: { primary: '#22c55e', secondary: '#0f172a' },
          },
          error: {
            iconTheme: { primary: '#ef4444', secondary: '#0f172a' },
          },
        }}
      />
    </div>
  );
}
